import React from 'react';
import { Skeleton } from '@duxton-web/ui';

const Loader = () => {
  return (
    <div style={{ padding: '16px 24px' }}>
      <Skeleton active loading paragraph={{ rows: 30 }} />
    </div>
  );
};

export default Loader;
